import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// ponytail: Supabase Image Transformation is a paid add-on and is OFF for this
// project (render endpoint returns 403 FeatureNotEnabled), so serve originals.
// Re-enable the add-on in the dashboard, then restore the /render/image/ rewrite.
export function getOptimizedImageUrl(url: string, _options: { width?: number; height?: number; quality?: number; resize?: 'cover' | 'contain' | 'fill' } = {}) {
  return url;
}
